import { render, staticRenderFns } from "./NoteBlock.vue?vue&type=template&id=0b29a50e&"
import script from "./NoteBlock.vue?vue&type=script&lang=js&"
export * from "./NoteBlock.vue?vue&type=script&lang=js&"
import style0 from "./NoteBlock.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "NoteBlock.vue"
export default component.exports